import HttpMethod from '@/consts/httpMethod';
import { processRequest, processSuccessResponse, processErrorResponse } from '@/helpers';
import { FEE_TYPES } from '@/consts';

export default {
  async getContractDetail(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/finflux-${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);
      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async rejectContract(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/finflux-${id}:reject/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async approveContract(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/finflux-${id}:approve/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep);
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async undoContractApproval(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/finflux-${id}:undo-approval/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep);
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async disburseContract(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/finflux-${id}:disburse/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async undoContractDisbursal(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/finflux-${id}:undo-disbursal/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep);
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async undoContractRepayment(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/finflux-${id}:undo-repayment/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep);
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async undoContractRenewal(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/finflux-${id}:undo-renewal/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep);
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async undoParentContractRenewal(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/${id}:undo-renewal/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep);
      const contract = processSuccessResponse(res);

      return contract;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getClient(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/clients/${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getContractNotes(contractId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}/notes/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          pageSize: -1
        }
      });

      const { items } = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addContractNotes(contractId, content) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}/notes/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {
        data: {
          content
        }
      });

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getAsset(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/assets/${id}/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getContractDocs(contractId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}/docs/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep, {
        params: {
          pageSize: -1
        }
      });

      const { items } = processSuccessResponse(res);

      return items;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getContractSummaryByMifosId(id) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/contracts/${id}/summary/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getRepaymentScheduleByMifosId(id) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/contracts/${id}/repayment-schedule/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getTransactionsByMifosId(id) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/contracts/${id}/transactions/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async uploadDocument(id, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${id}/docs/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });

      const result = processSuccessResponse(res);

      return result;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async deleteDocument(id) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contract-docs/${id}:archive/`,
      method: HttpMethod.POST
    };

    try {
      await processRequest(ep);

      return true;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async getCollateralInfo(id) {
    const ep = {
      baseURL: process.env.VUE_APP_API_ROOT,
      url: `/v1/contracts/${id}/collateral-info/`,
      method: HttpMethod.GET
    };

    try {
      const res = await processRequest(ep);

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async chargeOverdueFee(contractId, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/${contractId}/fees/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data: { ...data, type: FEE_TYPES.OVERDUE } });
      const fee = processSuccessResponse(res);

      return fee;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async addTransaction(contractId, data) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `v2/contracts/${contractId}/transactions/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, { data });
      const transaction = processSuccessResponse(res);

      return transaction;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  },

  async sendRenewedNotification(contractId) {
    const ep = {
      baseURL: process.env.VUE_APP_CRM_API_ROOT,
      url: `/v2/contracts/${contractId}:send-renewed-notification/`,
      method: HttpMethod.POST
    };

    try {
      const res = await processRequest(ep, {});

      const data = processSuccessResponse(res);

      return data;
    } catch(e) {
      processErrorResponse(e.response);
      return false;
    }
  }
};
